// frontend/src/constants/profileLabels.js
//
// Shared label maps for profile fields. Imported by ProfilePage.js (own-profile
// editor), UserProfilePage.js (public profile), and UserProfileView.js (shared
// profile-card component).
//
// Target-area keys cover both the legacy 7-key onboarding set AND the 10-key
// anatomy split used by the current profile editor. Both are still present in
// the production DB; rendering must handle either shape.

export const TARGET_AREA_LABELS = {
  // Current 10-key anatomy split (ProfilePage.js editor)
  chest: 'Chest',
  back: 'Back',
  shoulders: 'Shoulders',
  upper_arms: 'Upper Arms',
  lower_arms: 'Lower Arms',
  upper_legs: 'Upper Legs',
  lower_legs: 'Lower Legs',
  waist: 'Waist',
  cardio: 'Cardio',
  neck: 'Neck',
  // Legacy 7-key onboarding set
  arms: 'Arms',
  core: 'Core',
  legs: 'Legs',
  glutes: 'Glutes',
};

export const TARGET_AREA_I18N_KEYS = {
  chest: 'userProfile.targetArea.chest',
  back: 'userProfile.targetArea.back',
  shoulders: 'userProfile.targetArea.shoulders',
  upper_arms: 'userProfile.targetArea.upperArms',
  lower_arms: 'userProfile.targetArea.lowerArms',
  upper_legs: 'userProfile.targetArea.upperLegs',
  lower_legs: 'userProfile.targetArea.lowerLegs',
  waist: 'userProfile.targetArea.waist',
  cardio: 'userProfile.targetArea.cardio',
  neck: 'userProfile.targetArea.neck',
  arms: 'userProfile.targetArea.arms',
  core: 'userProfile.targetArea.core',
  legs: 'userProfile.targetArea.legs',
  glutes: 'userProfile.targetArea.glutes',
};

export const GOAL_LABELS = {
  weight_loss: 'Weight Loss',
  muscle_gain: 'Muscle Gain',
  strength: 'Strength',
  endurance: 'Endurance',
  flexibility: 'Flexibility',
  general_fitness: 'General Fitness',
  // Legacy synonyms still seen in the DB
  lose_weight: 'Lose Weight',
  maintain_weight: 'Maintain',
  gain_weight: 'Gain Weight',
};

export const EXPERIENCE_LABELS = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
};

export const EQUIPMENT_LABELS = {
  full_gym: 'Full Gym',
  home_basic: 'Home Basic',
  bodyweight_only: 'Bodyweight Only',
};

export const ACTIVITY_LABELS = {
  sedentary: 'Sedentary',
  lightly_active: 'Lightly Active',
  moderately_active: 'Moderately Active',
  very_active: 'Very Active',
  extremely_active: 'Extremely Active',
};
